import { useEffect, useState } from 'react';
import type { Session } from './types';
import { getSession, setCsrfToken } from './api';
import { LoginPage } from './LoginPage';
import { PasswordChange } from './PasswordChange';
import { DealerApp } from './DealerApp';
import { AdminApp } from './AdminApp';
import { BrandLogo } from './components';

export function App() {
  const [session, setSession] = useState<Session | null | undefined>(undefined);

  useEffect(() => {
    let active = true;
    let refreshing = false;
    async function refresh() {
      if (refreshing) return;
      refreshing = true;
      try {
        const current = await getSession();
        if (active) setSession((previous) => JSON.stringify(previous) === JSON.stringify(current) ? previous : current);
      } catch {
        if (active) setSession((previous) => previous === undefined ? null : previous);
      } finally { refreshing = false; }
    }
    const onVisible = () => { if (document.visibilityState === 'visible') void refresh(); };
    void refresh();
    window.addEventListener('focus', onVisible);
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('account-permissions-changed', onVisible);
    const timer = window.setInterval(onVisible, 30_000);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', onVisible);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('account-permissions-changed', onVisible);
    };
  }, []);

  if (session === undefined) {
    return <main className="boot-screen"><BrandLogo /><p>正在连接阳江龙杰日丰订货系统</p></main>;
  }
  if (!session) return <LoginPage onLogin={setSession} />;
  if (session.user.mustChangePassword) {
    return <PasswordChange onChanged={() => setSession({ ...session, user: { ...session.user, mustChangePassword: false } })} />;
  }
  const logout = () => { setCsrfToken(''); setSession(null); };
  return session.user.accountType === 'DEALER'
    ? <DealerApp user={session.user} onLogout={logout} />
    : <AdminApp
        user={session.user}
        inventoryEnabled={session.features?.inventory ?? false}
        onLogout={logout}
      />;
}
